export enum GuestStayForms {
  ChangeRooms = 'ChangeRooms',
}
